module.exports = __webpack_public_path__ + "static/media/3DPPA31.7f1b9b50.jpg";